import React, { useState } from "react";
import { Search, ChevronLeft, ChevronRight } from "lucide-react";

export default function SalesSummary() {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    orderStatus: "All",
    paymentStatus: "All",
    category: "",
    manufacturer: "",
    billingCountry: "",
    vendor: "",
    product: "",
    groupBy: "",
  });

  const [data] = useState([
    {
      date: "Nov 04, 2025",
      orders: 5,
      profit: "$4,469.30",
      shipping: "$0.00",
      tax: "$0.00",
      total: "$4,469.30",
    },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    alert("Search applied!");
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <h1 className="text-xl font-semibold text-gray-800 mb-4">Sales Summary</h1>

      {/* 🔍 Filter/Search Section */}
      <form
        onSubmit={handleSearch}
        className="bg-white border rounded-lg shadow-sm p-4 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6"
      >
        <div>
          <label className="block text-sm text-gray-600 mb-1">Start date</label>
          <input
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">End date</label>
          <input
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Order status</label>
          <select
            name="orderStatus"
            value={filters.orderStatus}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          >
            <option>All</option>
            <option>Pending</option>
            <option>Completed</option>
            <option>Cancelled</option>
          </select>
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Payment status</label>
          <select
            name="paymentStatus"
            value={filters.paymentStatus}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          >
            <option>All</option>
            <option>Paid</option>
            <option>Unpaid</option>
            <option>Refunded</option>
          </select>
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Category</label>
          <input
            name="category"
            type="text"
            placeholder="Enter category"
            value={filters.category}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Manufacturer</label>
          <input
            name="manufacturer"
            type="text"
            placeholder="Enter manufacturer"
            value={filters.manufacturer}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Billing country</label>
          <input
            name="billingCountry"
            type="text"
            placeholder="Enter country"
            value={filters.billingCountry}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Vendor</label>
          <input
            name="vendor"
            type="text"
            placeholder="Enter vendor"
            value={filters.vendor}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Product</label>
          <input
            name="product"
            type="text"
            placeholder="Enter product"
            value={filters.product}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Group by</label>
          <input
            name="groupBy"
            type="text"
            placeholder="e.g. Date"
            value={filters.groupBy}
            onChange={handleInputChange}
            className="w-full border rounded-md p-2 text-sm"
          />
        </div>

        <div className="flex items-end">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm flex items-center gap-2 w-full justify-center"
          >
            <Search size={16} /> Search
          </button>
        </div>
      </form>

      {/* ℹ️ Learn More Section */}
      <div className="flex flex-wrap items-center justify-between mb-3 text-sm text-gray-600">
        <span>Learn more about reports</span>
        <span className="text-gray-400">Summary</span>
      </div>

      {/* 📊 Data Table */}
      <div className="bg-white border rounded-lg shadow-sm overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-2 border text-left">Date</th>
              <th className="p-2 border text-center">Number of orders</th>
              <th className="p-2 border text-center">Profit</th>
              <th className="p-2 border text-center">Shipping</th>
              <th className="p-2 border text-center">Tax</th>
              <th className="p-2 border text-center">Order Total</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="p-2 border">{row.date}</td>
                <td className="p-2 border text-center">{row.orders}</td>
                <td className="p-2 border text-center">{row.profit}</td>
                <td className="p-2 border text-center">{row.shipping}</td>
                <td className="p-2 border text-center">{row.tax}</td>
                <td className="p-2 border text-center">{row.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 📄 Pagination */}
      <div className="flex flex-col md:flex-row justify-between items-center text-sm p-4 border bg-white mt-2 rounded-lg">
        <div className="flex items-center gap-2">
          <button className="p-1 border rounded-md hover:bg-gray-100">
            <ChevronLeft size={16} />
          </button>
          <span>1</span>
          <button className="p-1 border rounded-md hover:bg-gray-100">
            <ChevronRight size={16} />
          </button>
          <span className="text-gray-500">of 1</span>
        </div>

        <div className="flex items-center gap-2 mt-2 md:mt-0">
          <span>Show</span>
          <select className="border rounded-md p-1 text-sm">
            <option>15</option>
            <option>25</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>

        <span className="text-gray-500 mt-2 md:mt-0">1–1 of 1 items</span>
      </div>
    </div>
  );
}
